import UpcomingLeavesWidget from "./UpcomingLeavesWidget";

import { isTerminal } from "../../../../constants";
import MultiWidget from "../../MultiWidget/MultiWidget";
import { userWidgetsThunkAction } from "../../../../redux/actions/User/profile/Widgets/Thunk/userWidgetsThunkAction";
import { getUpcomingLeavesThunkAction } from "../../../../redux/actions/User/profile/Widgets/Thunk/getUpcomingLeaves.thunk.action";
import DropdownForAppointment from "../DropdownForAppointment/DropdownForAppointment";

import { $api } from "../../../../redux/services/request.config";

import { isLeaderThunkAction } from "../../../../redux/actions/Auth/Thunk/isLeader.thunk.action";
import {
    getMealCardBalanceThunkAction,
} from "../../../../redux/actions/User/profile/Widgets/Thunk/getFoodCardBalance.thunk.action";
import {
    setActiveAppointmentAction,
} from "../../../../redux/actions/User/profile/WorkAppontments/setActiveAppointment.action";


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

isTerminal ? import("./InformationWidgetsPartTerminal.scss") : import("./InformationWidgetsPart.scss");


const InformationWidgetsPart = (
    {
        handleClick,
        clickHandlerWidgets,
    },
) => {

    const dispatch = useDispatch();

    const widgets = useSelector((state) => state.personalData?.widgets);
    const foodCard = useSelector((state) => state.personalData?.foodCard);
    const upcomingLeaves = useSelector((state) => state.personalData?.upcomingLeaves);
    const user = useSelector(state => state.user);
    const [fio] = useState(JSON.parse(localStorage.getItem("fio")));
    const [appointment] = useState(localStorage.getItem("appointment"));
    const [requestOption, setRequestOption] = useState(null);

    // console.log(requestOption);

    function selectOptionClick(event, element, stateProperty) {
        localStorage.setItem("appointment", element.name);
        setRequestOption(element.id);
        // console.log($api.defaults.headers);
        $api.defaults.headers.common["pid"] = element.id;
        dispatch(userWidgetsThunkAction());
        dispatch(isLeaderThunkAction());
        dispatch(setActiveAppointmentAction(element.id));

    }

    useEffect(() => {
        dispatch(userWidgetsThunkAction());
        dispatch(getMealCardBalanceThunkAction());
        dispatch(getUpcomingLeavesThunkAction());
        // return () => {
        //     dispatch(unsetFoodCardBalanceAction());
        // };
        // setRequestOption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <div className="information-part">
            <div className="information-part__name">
                {fio ?
                    <span className="information-part__name__fio">
                        {
                            fio.lastNameRu
                        }
                        <br />
                        {
                            fio.firstNameRu
                        }
                        {" "}
                        {
                            fio.secondNameRu
                        }
                    </span>
                    :
                    <p style={{ minWidth: "343px" }}>
                        <br />
                    </p>

                }

                {
                    appointment ?
                        <DropdownForAppointment
                            // optionsLoader={typesListLoader}
                            styleName={"lists"}
                            // label={"заявки по рабочему времени"}
                            initialMenuMessage={localStorage.getItem("appointment") ? localStorage.getItem("appointment") : "Выберите назначение"}
                            listOfOptions={user && user.appointments ? user.appointments : []}
                            // stateProperty={"leaveTypeId"}
                            // currentRequest={currentRequest}
                            selectOptionClick={selectOptionClick}
                            // showBackButton={isTerminal}
                        />
                        // ? <p className='information-part__name__appointment'>
                        //     {appointment}
                        // </p>
                        : <p>

                        </p>
                }

            </div>
            <div className={"information-part__widgets"}>
                {foodCard &&
                    <div style={{ minWidth: "150px" }}
                        className={"information-part__widgets__item"}>
                        <div style={{ maxWidth: "100px" }} className={"information-part__widgets__block-head"}>
                            {"Остаток по карте питания "}
                        </div>
                        <div className={"information-part__widgets__description"}>
                            {foodCard?.balance}{" руб"}
                        </div>
                    </div>}

                {widgets && (
                    <>
                        <MultiWidget
                            data={widgets.filter((w) => w.title !== "Предстоящий отпуск")}
                            styleParent={"information-part__widgets"} />
                        {widgets.find((w) => w.title === "Предстоящий отпуск") && (
                            <UpcomingLeavesWidget
                                description={widgets.find((w) => w.title === "Предстоящий отпуск").description}
                                leaves={upcomingLeaves || []}
                            />
                        )}
                    </>
                )}
            </div>

        </div>
    );
};

export default InformationWidgetsPart;
